import React, { useState } from 'react';
import api from '../api/axios';
import { useTranslation, Trans } from 'react-i18next';

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/auth/forgot-password', { email });
      setMessage(t('reset-password.alerts.reset-link-sent'));
    } catch (err) {
      setMessage(t('reset-password.alerts.reset-link-sent'));
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-4">{t('reset-password.title')}</h2>
      {message && <p className="mb-4 text-blue-600 font-bold">{message}</p>}
      <form onSubmit={handleSubmit}>
        <label className="block mb-2 text-sm font-bold">{t('reset-password.email-placeholder')}</label>
        <input 
          type="email" 
          className="w-full border p-2 rounded mb-4"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <button className="w-full bg-[#1d5cab] hover:bg-[#2372bd] text-white font-bold py-2 rounded">
          {t('reset-password.submit-button')}
        </button>
      </form>
    </div>
  );
};
export default ForgotPasswordPage;
